/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================
   Sticky bar "Buy Now" - Rubber Roof UK cut-to-size product pages

   The sticky bar carries its own Buy Now link, hardcoded to /checkout.
   Like the main button before it was fixed, it sent the customer to
   checkout WITHOUT ever adding the configured sheet to the basket, so
   they landed on an empty cart. Rather than duplicate the add-then-
   checkout logic here, the bar's link is rewired to trigger the main
   #calc-buy-now-btn, which already validates the size, honours the
   "cut to order" confirmation tick and adds the line before forwarding
   to checkout. One code path, one place to maintain it.
   ============================================================ */
(function () {
  function wireStickyBuyNow() {
    var bar  = document.getElementById('rr-sticky-bar');
    var main = document.getElementById('calc-buy-now-btn');
    if (!bar || !main) { return; }

    var link = bar.querySelector('#rr-bar-buy-now') ||
               bar.querySelector('a[href="/checkout"]') ||
               bar.querySelector('a[href="/cart"]');
    if (!link || link.dataset.rrukWired) { return; }
    link.dataset.rrukWired = '1';

    /* Keep a real href so the link stays keyboard and middle-click sane. */
    link.setAttribute('href', '/cart');
    link.addEventListener('click', function (e) {
      e.preventDefault();
      main.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireStickyBuyNow);
  } else {
    wireStickyBuyNow();
  }
})();
